import HTTP from '.';
import TimeEntryServiceMock from './mocks/TimeEntryService.mock';
import config from '@/config';

export default class TimeEntryService {
  static getTimeEntryById(id) {
    if (config.ENV.MOCK === true) {
      return TimeEntryServiceMock.getTimeEntryById();
    }

    return HTTP.get(`/api/currentmember/timeentries/${id}`);
  }

  static getCurrentWeekTimeEntries() {
    if (config.ENV.MOCK === true) {
      return TimeEntryServiceMock.getCurrentWeekTimeEntries();
    }

    return HTTP.get('/api/currentmember/timeentries/currentweek');
  }

  static getWeekTimeEntriesFromDate(fromDate, toDate) {
    if (config.ENV.MOCK === true) {
      return TimeEntryServiceMock.getWeekTimeEntriesFromDate();
    }

    return HTTP.get('/api/currentmember/timeentries/search', {
      params: {
        'DateRange.From': fromDate,
        'DateRange.To': toDate,
      },
    });
  }

  static addTimeEntry(data) {
    if (config.ENV.MOCK === true) {
      return TimeEntryServiceMock.addTimeEntry();
    }

    return HTTP.post('/api/currentmember/timeentries', data);
  }

  static deleteTimeEntry(id) {
    if (config.ENV.MOCK === true) {
      return TimeEntryServiceMock.deleteTimeEntry();
    }

    return HTTP.delete(`/api/currentmember/timeentries/${id}`);
  }

  static saveTimeEntry(id, data) {
    if (config.ENV.MOCK === true) {
      return TimeEntryServiceMock.saveTimeEntry();
    }

    return HTTP.put(`/api/currentmember/timeentries/${id}`, data);
  }

  static submit(date) {
    if (config.ENV.MOCK === true) {
      return TimeEntryServiceMock.submit();
    }

    return HTTP.post('/api/currentmember/timeentries/submitweek', {
      dayOfWeek: date,
    });
  }
}
